// Page « module non activé » (MOKA-402) : libellés et adresse, logique pure testée.
import { ModuleFlagKey } from '../../services/subscription-features.service';

/** Slug d'adresse (/module-inactif/:module) ↔ drapeau de l'abonnement. */
export const INACTIVE_MODULES: Record<string, { key: ModuleFlagKey; label: string; icon: string }> = {
  calendrier: { key: 'calendars_enable', label: 'Calendrier et salles', icon: 'iconoirCalendar' },
  projets: { key: 'projects_enable', label: 'Projets', icon: 'iconoirList' },
  rh: { key: 'human_resources_enable', label: 'RH & carrière', icon: 'iconoirUser' },
  inventaire: { key: 'inventory_enable', label: 'Inventaire', icon: 'iconoirBox' },
};

/** Slug du module désactivé, pour la redirection du garde. */
export function inactiveModuleSlug(moduleKey: ModuleFlagKey): string {
  return Object.entries(INACTIVE_MODULES).find(([, m]) => m.key === moduleKey)?.[0] ?? 'rh';
}
